import { render, staticRenderFns } from "./SEntrega99Info.vue?vue&type=template&id=c44aac28&scoped=true"
import script from "./SEntrega99Info.vue?vue&type=script&lang=js"
export * from "./SEntrega99Info.vue?vue&type=script&lang=js"
import style0 from "./SEntrega99Info.vue?vue&type=style&index=0&id=c44aac28&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c44aac28",
  null
  
)

export default component.exports